import { Routes, Route } from "react-router-dom";
import SmoothScroll from "./Components/SmoothScroll";
import ScrollProgress from "./Components/ScrollProgress";
import ScrollToTop from "./Components/ScrollToTop";
import LegacyRedirect from "./Components/LegacyRedirect";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import MobileCTA from "./Components/MobileCTA";
import Home from "./Pages/Home";
import ServicePage from "./Pages/ServicePage";
import Cleaning from "./Pages/Cleaning";
import Contact from "./Pages/Contact";
import Imprint from "./Pages/Imprint";
import Privacy from "./Pages/Privacy";
import NotFound from "./Pages/NotFound";
import "./styles.css";

export default function App() {
  return (
    <SmoothScroll>
      <a className="skip-link" href="#main">
        Zum Inhalt springen
      </a>
      <ScrollProgress />
      <ScrollToTop />
      <LegacyRedirect />
      <Header />
      <main id="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leistungen/:slug" element={<ServicePage />} />
          <Route path="/reinigung" element={<Cleaning />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/impressum" element={<Imprint />} />
          <Route path="/datenschutz" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <MobileCTA />
    </SmoothScroll>
  );
}
